<template>
  <transition name="fade" mode="out-in">
    <loading-screen v-if="loading"></loading-screen>
    <main-view v-else></main-view>
  </transition>
</template>

<script>
  import LoadingScreen from './components/LoadingScreen.vue'
  import MainView from './views/Main.vue'

  import { mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    components: {
      LoadingScreen,
      MainView
    },

    data() {
      return {
        loading: false
      }
    },

    computed: {
      ...mapGetters('auth', ['initialRoute'])
    },

    created() {
      const token = /token=(.*);?/.exec(document.cookie)

      // if token doesn't exists redirect to login
      if (token) {
        this.loading = true
        this.storeToken(token[1])

        // if token exists check if it is valid
        this.axios.post('/refresh')
          .then(res => {
            this.storeToken(res.data.access_token)
            this.storeTokenInCookie({ token: res.data.access_token, expiresIn: res.data.expires_in })
            this.setTimerForTokenRefresh(res.data.expires_in)

            // if token is valid fetch user and redirect it to his initial path
            // route guards now will handle his permissions for the URL
            this.axios.get('/me')
              .then(res => {
                this.storeUser(res.data.data)
                this.loading = false

                // route is stored at auth middleware @router/middlewares.js/auth()
                this.$router.push({ name: this.initialRoute.name })
              })
              .catch(error => {
                this.clearUser()
              })

          })
          .catch(errors => {
            this.clearUser()
            this.$router.push({ name: 'login' })
          })
      }
    },

    methods: {
      ...mapMutations('auth', ['storeToken', 'storeUser']),
      ...mapActions('auth', ['clearUser', 'storeTokenInCookie', 'setTimerForTokenRefresh']),
    }
  }
</script>
<style lang="scss">
  @import 'app.scss';

  .m-stack.m-stack--desktop {
    display:block !important;
  }
  @media (max-width: 576px) {
    .sm-hide {
      display: none !important;
    }
    .sm-show {
      display: block !important;
    }

    .awn-top {
      top: auto !important;
      bottom: 24px !important;
    }
    .text-sm-center {
      text-align: center;
    }
  }

  @media (min-width: 576px) {
    .sm-show {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue